module.exports = "<div class=\"footer\">\n    &copy; 2018 All rights reserved. Atomic Mole, LLC.\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/ui/footer/footer.component.html
// module id = ../../../../../src/app/ui/footer/footer.component.html
// module chunks = main